export class KJSData {
    constructor() {}

    Jbbk: string;
    Trezor: string;
    Mb: string;
    Pib: string;
    Naziv: string;
    Mesto: string;
    Adresa: string;
    Sediste: number;
    OrganizacioniTipPodtip: string;
    FunkcionalnaKlasifikacija: string;
    EMail: string;
    GrupaPodgrupa: string;
    DirektniBKNaziv: string;
    SedisteNaziv: string;
    Tip: string;
    Aktivnost: string;

    Deserialize(input: any){
        this.Jbbk = input.Jbbk;
        this.Trezor = input.Trezor;
        this.Mb = input.Mb;
        this.Pib = input.Pib;
        this.Naziv = input.Naziv;
        this.Mesto = input.Mesto;
        this.Adresa = input.Adresa;
        this.Sediste = input.Sediste;
        this.OrganizacioniTipPodtip = input.OrganizacioniTipPodtip;
        this.FunkcionalnaKlasifikacija = input.FunkcionalnaKlasifikacija;
        this.EMail = input.EMail;
        this.GrupaPodgrupa = input.GrupaPodgrupa;
        this.DirektniBKNaziv = input.DirektniBKNaziv;
        this.SedisteNaziv = input.SedisteNaziv;
        this.Tip = input.Tip;
        this.Aktivnost = input.Aktivnost;
        return this;
    }
}